import { render, staticRenderFns } from "./guide-basic-component.vue?vue&type=template&id=69a86d92&scoped=true"
import script from "./guide-basic-component.vue?vue&type=script&lang=js"
export * from "./guide-basic-component.vue?vue&type=script&lang=js"
import style0 from "./guide-basic-component.vue?vue&type=style&index=0&id=69a86d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a86d92",
  null
  
)

export default component.exports